interface CategoryBreakdownEntry {
  co2Emissions?: number;
  co2?: number;
  count?: number;
  amount?: number;
}

interface MobileBreakdownEntry {
  co2?: number;
  co2Emissions?: number;
  emissions?: number;
  count?: number;
  amount?: number;
}

interface CarbonStatsLike {
  categoryBreakdown?: Record<string, CategoryBreakdownEntry> | null;
  mobileBreakdown?: Record<string, MobileBreakdownEntry | unknown> | null;
  esgScopes?: {
    scope1?: { total?: number; breakdown?: Record<string, number> };
    scope2?: { total?: number; breakdown?: Record<string, number> };
    scope3?: { total?: number; breakdown?: Record<string, number> };
  } | null;
}

const SKIP_MOBILE_KEYS = new Set(['periodWise', 'categoryBreakdown', 'source', 'metadata']);

export const mapMobileBreakdownToCategoryBreakdown = (
  mobileBreakdown?: Record<string, MobileBreakdownEntry | unknown> | null
): Record<string, CategoryBreakdownEntry> | null => {
  if (!mobileBreakdown || typeof mobileBreakdown !== 'object') {
    return null;
  }

  const result: Record<string, CategoryBreakdownEntry> = {};
  Object.entries(mobileBreakdown).forEach(([key, value]) => {
    if (SKIP_MOBILE_KEYS.has(key) || !value || typeof value !== 'object') {
      return;
    }
    const entry = value as MobileBreakdownEntry;
    const co2Emissions = Number(entry.co2 ?? entry.co2Emissions ?? entry.emissions ?? 0) || 0;
    const count = Number(entry.count ?? 0) || 0;
    const amount = Number(entry.amount ?? 0) || 0;
    if (co2Emissions <= 0 && count <= 0 && amount <= 0) {
      return;
    }
    result[key] = { co2Emissions, count, amount };
  });

  return Object.keys(result).length > 0 ? result : null;
};

export const resolveDashboardCarbonFields = (
  carbon?: CarbonStatsLike | null,
  dashboardCategoryBreakdown?: Record<string, CategoryBreakdownEntry> | null
): {
  categoryBreakdown: Record<string, CategoryBreakdownEntry> | null;
  esgScopes: CarbonStatsLike['esgScopes'];
} => {
  let categoryBreakdown = carbon?.categoryBreakdown ?? null;
  if (!categoryBreakdown || Object.keys(categoryBreakdown).length === 0) {
    categoryBreakdown = mapMobileBreakdownToCategoryBreakdown(carbon?.mobileBreakdown ?? null);
  }
  if (!categoryBreakdown || Object.keys(categoryBreakdown).length === 0) {
    categoryBreakdown = dashboardCategoryBreakdown ?? null;
  }

  return {
    categoryBreakdown,
    esgScopes: carbon?.esgScopes ?? null,
  };
};
